// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_array from "../../../../../node_modules/rescript/lib/es6/js_array.js";
import * as Js_promise from "../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Router from "next/router";
import Script from "next/script";
import * as GTM$PorterinUtils from "../../../../../node_modules/@porterin/utils/src/gtm/GTM.mjs";
import * as Log$PorterinUtils from "../../../../../node_modules/@porterin/utils/src/helpers/Log.mjs";
import * as UrlUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.mjs";
import * as Config$PorterinUtils from "../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as MediaQuery$PorterinUtils from "../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as CookieUtils$PorterinFeature from "../fare-estimate-v1/utils/browser/CookieUtils.mjs";
import * as SentryBinding$PorterinUtils from "../../../../../node_modules/@porterin/utils/src/bindings/sentry/SentryBinding.mjs";
import * as EventPublisher$PorterinUtils from "../../../../../node_modules/@porterin/utils/src/pageview-logs/EventPublisher.mjs";
import * as InitializeGa$PorterinFeature from "../../shared/google-analytics/InitializeGa.mjs";
import * as LocaleConstants$PorterinUtils from "../../../../../node_modules/@porterin/utils/src/constants/LocaleConstants.mjs";
import * as AppConfigHelpers$PorterinUtils from "../../../../../node_modules/@porterin/utils/src/helpers/AppConfigHelpers.mjs";
import * as MoEngageScripts$PorterinFeature from "./MoEngageScripts.mjs";
import * as PageviewLogPayload$PorterinUtils from "../../../../../node_modules/@porterin/utils/src/pageview-logs/PageviewLogPayload.mjs";
import * as CookieConsentConfig$PorterinFeature from "../../shared/cookie-consent-manager/config/CookieConsentConfig.mjs";
import * as CookieConsentManager$PorterinCookieConsentManager from "../../../../../node_modules/@porterin/cookie-consent-manager/src/interface/CookieConsentManager.mjs";
import * as CookieConsentConstants$PorterinCookieConsentManager from "../../../../../node_modules/@porterin/cookie-consent-manager/src/constants/CookieConsentConstants.mjs";

import 'vanilla-cookieconsent/dist/cookieconsent.css'
;

import '@porterin/feature/src/shared/cookie-consent-manager/styles/cookie-consent-manager.scss'
;

import 'react-loading-skeleton/dist/skeleton.css'
;

var PageComponent = {};

function dispatchConsentEvent(param) {
  var $$event = new (window.Event)("cookie-consent-updated");
  window.dispatchEvent($$event);
}

function $$default(props) {
  var match = Router.useRouter();
  var locale = match.locale;
  var router = Router.useRouter();
  var isDesktop = MediaQuery$PorterinUtils.useMediaQuery("(min-width: 560px)");
  var shouldShowCookieConsent = Js_array.includes(locale, LocaleConstants$PorterinUtils.trLocales) ? true : false;
  var match$1 = React.useState(function () {
        return false;
      });
  var setShouldInitializeGa = match$1[1];
  var timeoutIdRef = React.useRef(undefined);
  var onChangeCookieConsent = function (param) {
    var preferences = CookieConsentManager$PorterinCookieConsentManager.getUserPreferences(undefined);
    if (Js_array.includes(CookieConsentConstants$PorterinCookieConsentManager.analytics_and_performance, preferences.acceptedCategories)) {
      return Curry._1(setShouldInitializeGa, (function (param) {
                    return true;
                  }));
    }
    
  };
  React.useEffect((function () {
          if (router.isReady) {
            EventPublisher$PorterinUtils.logPageview(PageviewLogPayload$PorterinUtils.makePayload(UrlUtils$Catalyst.getURLParams(UrlUtils$Catalyst.getSearchParams(window.location.href)), locale));
          }
          
        }), [
        router.asPath,
        router.isReady
      ]);
  React.useEffect((function () {
          Log$PorterinUtils.devLog("ENV", Config$PorterinUtils.env);
          Log$PorterinUtils.devLog("LOCALE", locale);
          if (Config$PorterinUtils.env === "production") {
            SentryBinding$PorterinUtils.init({
                  dsn: Config$PorterinUtils.sentry_dsn,
                  env: Config$PorterinUtils.env,
                  tracesSampleRate: 0.1,
                  replaysSessionSampleRate: 0.01,
                  replaysOnErrorSampleRate: 0.01,
                  release: "fe-website-platform"
                });
          }
          
        }), []);
  React.useEffect((function () {
          if (shouldShowCookieConsent) {
            window.addEventListener("cookie-consent-updated", onChangeCookieConsent);
            Js_promise.$$catch((function (param) {
                    return Promise.resolve(undefined);
                  }), Js_promise.then_((function (param) {
                        timeoutIdRef.current = Caml_option.some(setTimeout(onChangeCookieConsent, 1000));
                        return Promise.resolve(undefined);
                      }), CookieConsentManager$PorterinCookieConsentManager.init(CookieConsentConfig$PorterinFeature.categories, CookieConsentConfig$PorterinFeature.translations, dispatchConsentEvent)));
            return (function (param) {
                      window.removeEventListener("cookie-consent-updated", onChangeCookieConsent);
                      var id = timeoutIdRef.current;
                      if (id !== undefined) {
                        clearTimeout(Caml_option.valFromOption(id));
                        return ;
                      }
                      
                    });
          }
          
        }), []);
  React.useEffect((function () {
          CookieUtils$PorterinFeature.deleteCookie("fe_params");
          CookieUtils$PorterinFeature.deleteCookie("or_params");
        }), []);
  return React.createElement(React.Fragment, undefined, Config$PorterinUtils.enable_gtm ? React.createElement(Script, {
                    strategy: "lazyOnload",
                    nonce: process.env.CSP_NONCE,
                    children: GTM$PorterinUtils.getGTMScript(Config$PorterinUtils.gtm_code)
                  }) : null, React.createElement(MoEngageScripts$PorterinFeature.make, {
                  router: router,
                  isDesktop: isDesktop
                }), !shouldShowCookieConsent || match$1[0] ? React.createElement(InitializeGa$PorterinFeature.make, {
                    load_ga_script: false,
                    measurement_id: AppConfigHelpers$PorterinUtils.getGaTrackingIdByLocale(locale),
                    tracker_name: locale === LocaleConstants$PorterinUtils.en_IN ? Config$PorterinUtils.ga_tracker_name_dom : Config$PorterinUtils.ga_tracker_name_int
                  }) : null, React.createElement(props.Component, props.pageProps));
}

export {
  PageComponent ,
  dispatchConsentEvent ,
  $$default ,
  $$default as default,
}
/*  Not a pure module */
